import React, { useEffect, useCallback } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { change } from 'redux-form'
const SELECTION_OPTIONS = ['Working', 'Not Working', "Didn't Check"]

export const DevicePartReportForm = ({
  unit_part_reports,
  editMode,
  FormName,
  unit_parts,
}) => {
  const dispatch = useDispatch()

  const onChange = useCallback((part, sp, e) => {
    dispatch(change(FormName, `unit_part_reports.${part}`, sp))
  })
  useEffect(() => {
    if (unit_parts && !editMode) {
      unit_parts.forEach((up) => {
        onChange(up.value, SELECTION_OPTIONS[2])
      })
    }
    if (unit_part_reports) {
      dispatch(change(FormName, `unit_part_reports`, unit_part_reports))
    }
  }, [FormName, dispatch, editMode, onChange, unit_parts, unit_part_reports])

  return (
    <ReactBootstrap.Table striped bordered hover>
      <thead>
        <tr>
          <th>Part</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {unit_part_reports &&
          unit_parts &&
          unit_parts.map((part, index) => {
            return (
              <tr>
                <th>{part.value}</th>
                <th>
                  <ReactBootstrap.Row>
                    <ReactBootstrap.Col xs={12}>
                      {SELECTION_OPTIONS.map((sp) => {
                        return (
                          <ReactBootstrap.Col
                            style={{
                              display: 'inline-flex',
                            }}
                            xs={4}
                          >
                            <ReactBootstrap.Form.Check
                              name={part.value}
                              type="radio"
                              checked={
                                unit_part_reports &&
                                unit_part_reports[part.value] === sp
                              }
                              onChange={(e) => {
                                onChange(part.value, sp, e)
                              }}
                              label={sp}
                            >
                              <ReactBootstrap.Form.Check.Input
                                checked={
                                  unit_part_reports &&
                                  unit_part_reports[part.value] === sp
                                }
                                onChange={(e) => {
                                  onChange(part.value, sp, e)
                                }}
                                id={part.value}
                                type="checkbox"
                              />
                              <ReactBootstrap.Form.Check.Label
                                onClick={(e) => {
                                  e.stopPropagation()
                                  onChange(part.value, sp, null)
                                }}
                                for={part.value}
                              >
                                {sp}
                              </ReactBootstrap.Form.Check.Label>
                            </ReactBootstrap.Form.Check>
                          </ReactBootstrap.Col>
                        )
                      })}
                    </ReactBootstrap.Col>
                  </ReactBootstrap.Row>
                </th>
              </tr>
            )
          })}
      </tbody>
    </ReactBootstrap.Table>
  )
}
